import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { DashboardService } from '../service/dashboard.service';
import { MatDialog } from '@angular/material';
import { ChangePinComponent } from '../dialogs/change-pin/change-pin.component';
import swal from 'sweetalert2';
import { DefaultComponent } from 'src/app/layouts/default/default.component';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-profile-account',
  templateUrl: './profile-account.component.html',
  styleUrls: ['./profile-account.component.scss'],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(16px)' }),
        animate('0.5s cubic-bezier(0.22, 1, 0.36, 1)', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ])
  ]
})

export class ProfileAccountComponent implements OnInit {

  sideBaropen = true;
  editingPersonal = false;

  profile = {
    id: '',
    email: '',
    firstName: '',
    lastName: '',
    managerEmail: '',
    phone: '',
    role: '',
    status: ''
  }

  appuser: any;
  mobile: boolean = true;

  /** Maps the stored role key to a human-readable label — mirrors toolbar & sidebar. */
  get roleLabel(): string {
    if (!this.appuser) { return ''; }
    const map: { [key: string]: string } = {
      'ADMIN':        'Administrator',
      'agent':        'Insurance Intermediary',
      'broker-admin': 'Broker Admin',
      'broker-user':  'Broker User',
      'client':       'Client'
    };
    return map[this.appuser.role] || (this.appuser.role || '');
  }

  constructor(
    public router: Router,
    public service: DashboardService,
    public formBuilder: FormBuilder,
    public DefaultComponent: DefaultComponent,
    private dialog: MatDialog
  ) {
    this.appuser = this.service.currentUser();
    this.profile.id           = this.appuser.code;
    this.profile.firstName    = this.appuser.first_name;   // legacy shape uses first_name
    this.profile.lastName     = this.appuser.last_name;    // legacy shape uses last_name
    this.profile.email        = this.appuser.email;
    this.profile.phone        = this.appuser.phone;
    this.profile.managerEmail = this.appuser.managerEmail;
  }

  ngOnInit(): void {
    this.DefaultComponent.getScreenWidth().subscribe(width => {
      if (width < 767) {
        console.log("mobile")
        this.mobile = true
      }
      else if
        (width > 767) {
        console.log("desktop")
        this.mobile = false
      }
    });

  }

  EditProfile() {

  }

  changePin() {
    const dialogRef = this.dialog.open(ChangePinComponent, {
      disableClose: true,
      width: '300px',
      data: {}
    });
    dialogRef.afterClosed().subscribe(result => { });
  }

  sideBarToggler() {
    this.DefaultComponent.sideBaropen = !this.DefaultComponent.sideBaropen
  }

}
